import ResultSection from './ResultSection';

export default ResultSection;
